import { Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Dashboard from './pages/Dashboard';
import Beneficiario from './pages/Beneficiario';
import Prestador from './pages/Prestador';
import Plano from './pages/Plano';
import Servico from './pages/Servico';
import Localizacao from './pages/Localizacao';
import Seguranca from './pages/Seguranca';
import Login from './pages/Login';
import { AuthProvider } from './auth/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <Header />
      <main className="main-content">
        <div className="container">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/beneficiarios" element={<ProtectedRoute tableName="beneficiario_CA001_BENEFICIARIO" operation="Select"><Beneficiario /></ProtectedRoute>} />
            <Route path="/prestadores" element={<ProtectedRoute tableName="prestador_CA001_PRESTADOR" operation="Select"><Prestador /></ProtectedRoute>} />
            <Route path="/planos" element={<ProtectedRoute tableName="plano_CA001_PLANO" operation="Select"><Plano /></ProtectedRoute>} />
            <Route path="/servicos" element={<ProtectedRoute tableName="servico_CA001_SERVICO" operation="Select"><Servico /></ProtectedRoute>} />
            <Route path="/localizacao" element={<ProtectedRoute tableName="localizacao_CA005_GRANDE_REGIAO" operation="Select"><Localizacao /></ProtectedRoute>} />
            <Route path="/seguranca" element={<ProtectedRoute tableName="seguranca_CA001_USUARIOS" operation="Select"><Seguranca /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </div>
      </main>
    </AuthProvider>
  );
}

export default App;